import axios from "axios";

import store from "@/main";
import router from "@/router";
import constants from "@/constants/url";
import { errorParser } from "@/utils";

const validAuthHandler = e => {
  const data = e.response ? e.response.data : {};

  switch (data.no) {
    case 1002:
    case 1003:
    case 1004:
      store.$store.commit("CLEAR_USER_DATA");
      router.push({ path: "/login" });
      errorParser.call(store, e);
      break;
    default:
      errorParser.call(store, e);
      break;
  }
  return;
};

export default {
  REQUEST({ state }, options) {
    // GET REQUEST (options - url)
    return new Promise((resolve, reject) => {
      const url = `${constants.URL}/${options.url}`;
      axios
        .get(url, {
          headers: { token: state.auth.token }
        })
        .then(data => resolve(data))
        .catch(error => {
          validAuthHandler(error);
          reject(error);
        });
    });
  },
  PUT_REQUEST({ state }, options) {
    // PUT REQUEST (param - url, data)
    return new Promise((resolve, reject) => {
      const url = `${constants.URL}/${options.url}`;
      axios
        .put(url, options.data, {
          headers: { token: state.auth.token }
        })
        .then(data => resolve(data))
        .catch(error => {
          validAuthHandler(error);
          reject(error);
        });
    });
  },
  POST_REQUEST({ state }, options) {
    // POST REQUEST (param - url, data)
    return new Promise((resolve, reject) => {
      const url = `${constants.URL}/${options.url}`;
      axios
        .post(url, options.data, {
          headers: { token: state.auth.token }
        })
        .then(data => resolve(data))
        .catch(error => {
          validAuthHandler(error);
          reject(error);
        });
    });
  },
  DELETE_REQUEST({ state }, options) {
    // DELETE REQUEST (param - url)
    return new Promise((resolve, reject) => {
      const url = `${constants.URL}/${options.url}`;
      axios
        .delete(url, {
          headers: { token: state.auth.token }
        })
        .then(data => resolve(data))
        .catch(error => {
          validAuthHandler(error);
          reject(error);
        });
    });
  },
  SEND_FORM_DATA({ state }, data) {
    // SEND FORM DATA (param - data)
    return new Promise((resolve, reject) => {
      const url = `${constants.URL}/${data.url}`;
      axios
        .post(url, data.data, {
          headers: {
            token: state.auth.token,
            "content-type": "multipart/form-data"
          }
        })
        .then(data => resolve(data))
        .catch(error => reject(error));
    });
  },
  POST_OSRM_REQUEST({ state }, { id }) {
    return new Promise((resolve, reject) => {
      const url = `${constants.BASE_URL}/osrm/start/${id}`;
      axios
        .post(
          url,
          {},
          {
            headers: { token: state.auth.token }
          }
        )
        .then(data => resolve(data))
        .catch(error => reject(error));
    });
  },
  ROUTE_REQUEST({ state }, options) {
    // GET REQUEST (options - url)
    return new Promise((resolve, reject) => {
      const url = `${constants.BASE_URL}/osrm/${options.url}`;
      axios
        .get(url, {
          headers: { token: state.auth.token }
        })
        .then(data => resolve(data))
        .catch(error => {
          reject(error);
        });
    });
  },
  GET_MODULE_USER_CONFIG({ state }, { module, id }) {
    if (!state.auth.user) return;
    if (module === "chart" || module === "map")
      id = state.profiles.currentProfile.id;
    return new Promise((resolve, reject) => {
      const url = `${
        constants.URL
      }/user/get_source_config?module=${module}&profile_tree_id=${id}`;
      axios
        .post(url, "", {
          headers: { token: state.auth.token }
        })
        .then(data => resolve(data))
        .catch(error => {
          validAuthHandler(error);
          reject(error);
        });
    });
  },
  SAVE_MODULE_USER_CONFIG({ state }, { module, id }) {
    if (!state.auth.user || !module) return;
    const book = {
      filters: state.book.filters,
      activeFields: state.book.activeFields
    };
    const charts = {
      charts: {
        charts_layouts: state.charts.chartsLayouts,
        opened_charts: state.charts.openedCharts
      }
    };
    const map = {
      bi_style_config: state.map.styleConfig,
      bi_requested_fields: state.map.requestedFields,
      bi_object_fields_configs: state.map.objectFieldsConfigs,
      bi_baselayer_id: state.user_config.baselayerId
    };
    let user_config;

    switch (module) {
      case "book":
        user_config = { ...book };
        break;
      case "chart":
        id = state.profiles.currentProfile.id;
        user_config = { ...charts };
        break;
      case "map":
        id = state.profiles.currentProfile.id;
        user_config = { ...map };
        break;
      default:
        break;
    }

    // if (module) {
    const xhr = new XMLHttpRequest();
    xhr.open(
      "POST",
      `${
        constants.URL
      }/user/set_source_config?module=${module}&profile_tree_id=${id}`,
      false
    );
    xhr.setRequestHeader("token", state.auth.token);
    xhr.send(JSON.stringify({ ...user_config }));
    return;
    // }

    // return new Promise((resolve, reject) => {
    //   const url = `${
    //     constants.URL
    //   }/user/set_source_config?module=${module}&profile_tree_id=${id}`;
    //   axios
    //     .post(url, user_config, {
    //       headers: { token: state.auth.token }
    //     })
    //     .then(data => resolve(data))
    //     .catch(error => {
    //       validAuthHandler(error);
    //       reject(error);
    //     });
    // });
  },
  SAVE_MAIN_USER_CONFIG({ state }, type) {
    if (!state.auth.user) return;
    let user_config = {
      id: state.profiles.currentProfile.id,
      locale: state.locale,
      default_path: state.defaultPath,
      theme: state.theme,
      desktops: {
        desktop: state.interface.desktop,
        overheadLayout: state.interface.overheadLayout
      },
      windows_configs: Array.isArray(state.interface.windowsConfigs)
        ? state.interface.windowsConfigs
        : [],
      sizes_config: state.interface.sizesConfig,
      book: {
        activeBook: {
          source_id: state.book.activeTable.source_id,
          id: state.book.activeTable.id,
          name: state.book.activeTable.name,
          geomType: state.book.activeTable.geomType,
          dataLength: state.book.activeTable.dataLength
        },
        treeExpandedNodes: state.profiles.treeExpandedNodes,
        treeScrollNode: state.profiles.treeScrollNode
      },
      map: {
        bi_style_config: state.map.styleConfig,
        bi_requested_fields: state.map.requestedFields,
        bi_object_fields_configs: state.map.objectFieldsConfigs,
        bi_baselayer_id: state.user_config.baselayerId,
        activeLayers: state.map.activeLayers
      },
      charts: {
        charts_layouts: state.charts.chartsLayouts,
        opened_charts: state.charts.openedCharts
      },
      sit_center: {
        disabledLayers: state.situationCenter.disabledLayers,
        objectCard: state.situationCenter.objectCard,
        layout: state.situationCenter.layout
      }
    };

    state.globalLoading = "loading";

    if (type === "unload") {
      navigator.sendBeacon(
        `${constants.URL}/user/profile?access_token=${state.auth.token}`,
        JSON.stringify({ ...user_config })
      );
      return;
    }

    return new Promise((resolve, reject) => {
      const url = `${constants.URL}/user/profile?`;
      axios
        .post(url, user_config, {
          headers: { token: state.auth.token }
        })
        .then(data => resolve(data))
        .catch(error => {
          validAuthHandler(error);
          reject(error);
        });
    });
  },
  SAVE_MAIN_USER_CONFIG_BY_ID({ state }, options) {
    if (!state.auth.user) return;
    let user_config = {
      id: options.id,
      locale: options.locale,
      theme: options.theme
    };

    state.globalLoading = "loading";

    return new Promise((resolve, reject) => {
      const url = `${constants.URL}/user/profile?`;
      axios
        .post(url, user_config, {
          headers: { token: state.auth.token }
        })
        .then(data => resolve(data))
        .catch(error => {
          validAuthHandler(error);
          reject(error);
        });
    });
  }
};
